var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Group, Layer } from './shapes/Group';
import './registry/initCore';
import { EventEmitter } from './core/EventEmitter';
import { Camera } from './camera/Camera';
import { EventManager } from './events/EventManager';
import { CanvasRenderer } from './renderers/CanvasRenderer';
import { createRenderer, hasRenderer } from './registry/renderers';
import { Timeline } from './animation/Timeline';
import { Rect, Circle, Ellipse, Line, Arc, Polygon, Polyline, Path, Star, RoundedRect, TextNode, ImageNode, Sprite, } from './shapes/index';
import { detectBestRenderer, getPixelRatio, resolveContainer, requestFrame, cancelFrame } from './utils';
import { fromJSON, exportStageJSON, isHoistableRootGroup } from './io/json';
import { exportScene, exportApp } from './io/export';
import { formatJsonParseError } from './io/schema';
import { installPlugin } from './plugins/index';
import { SpatialIndex } from './performance/SpatialIndex';
import { getWorldBounds, countNodes } from './performance/bounds';
import { AnimationEngine } from './animation/Animation';
import { collectFocusable } from './utils/focusOrder';
import { resolveUiTheme, resolveThemeBackground } from './components/uiTheme';
import { syntheticEvent } from './components/helpers';
import { syncActiveCanvasUiTheme, refreshCanvasUi } from './components/resolveCanvasTheme';
import { syncActiveDashboardTheme, refreshDashboard } from './dashboard/theme';
import { syncActiveDiagramTheme } from './diagram/theme';
import { refreshDiagram } from './diagram/refresh';
import { syncAutomotiveFontScale, getAutomotiveFontScale, syncAutomotiveDefaultPreset } from './automotive/themes';
import { refreshAutomotive } from './automotive/refresh';
import { splitThemePack, mergeThemePacks, normalizeThemePack, extractSceneTheme, composeThemePack, } from './theme/themePack';
import { hitTestNode, hitTestSpatial } from './app/hitTest';
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(container, options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var _this = _super.call(this) || this;
        _this.eventManager = null;
        _this.renderScheduled = false;
        _this.renderFrameId = 0;
        _this.resizeHandler = null;
        _this.spatialIndex = new SpatialIndex();
        _this.nodeCount = 0;
        /** Module packs stored alongside brand tokens. */
        _this.themeModules = {};
        /** True when app `fontSize` changed automotive typography scale (rebuild HMI). */
        _this.automotiveFontScaleDirty = false;
        _this.highContrast = (_a = options.highContrast) !== null && _a !== void 0 ? _a : false;
        _this.uiTheme = {};
        _this.resolvedUiTheme = {};
        _this.ingestThemePack(normalizeThemePack((_b = options.uiTheme) !== null && _b !== void 0 ? _b : {}), true);
        _this.perf = {
            spatialIndex: (_d = (_c = options.performance) === null || _c === void 0 ? void 0 : _c.spatialIndex) !== null && _d !== void 0 ? _d : true,
            spatialIndexThreshold: (_f = (_e = options.performance) === null || _e === void 0 ? void 0 : _e.spatialIndexThreshold) !== null && _f !== void 0 ? _f : 100,
            dirtyRegions: (_h = (_g = options.performance) === null || _g === void 0 ? void 0 : _g.dirtyRegions) !== null && _h !== void 0 ? _h : true,
            batchRendering: (_k = (_j = options.performance) === null || _j === void 0 ? void 0 : _j.batchRendering) !== null && _k !== void 0 ? _k : true,
            layerCache: (_m = (_l = options.performance) === null || _l === void 0 ? void 0 : _l.layerCache) !== null && _m !== void 0 ? _m : true,
        };
        _this.container = resolveContainer(container);
        _this.width = (_o = options.width) !== null && _o !== void 0 ? _o : (_this.container.clientWidth || 800);
        _this.height = (_p = options.height) !== null && _p !== void 0 ? _p : (_this.container.clientHeight || 600);
        _this.pixelRatio = (_q = options.pixelRatio) !== null && _q !== void 0 ? _q : getPixelRatio();
        _this.defaultBackground = (_r = options.background) !== null && _r !== void 0 ? _r : 'transparent';
        _this.background = _this.defaultBackground;
        _this.autoResize = (_s = options.autoResize) !== null && _s !== void 0 ? _s : true;
        _this.stage = new Group({ name: 'stage' });
        _this.stage._app = _this;
        _this.camera = new Camera(_this);
        _this.camera.setViewport(_this.width, _this.height);
        _this.renderer = _this.createRenderer((_t = options.renderer) !== null && _t !== void 0 ? _t : 'auto');
        _this.applyPerformanceOptions();
        _this.renderer.init(_this.container, {
            width: _this.width,
            height: _this.height,
            pixelRatio: _this.pixelRatio,
            background: _this.background,
            highContrast: _this.highContrast,
            uiTheme: _this.resolvedUiTheme,
        });
        // Re-apply theme-driven stage background after renderer exists.
        _this.syncThemeBackground();
        _this.eventManager = new EventManager(_this, _this.renderer.getElement());
        if (_this.autoResize && typeof window !== 'undefined') {
            _this.resizeHandler = function () { return _this.handleResize(); };
            window.addEventListener('resize', _this.resizeHandler);
        }
        _this.render();
        return _this;
    }
    App.prototype.applyPerformanceOptions = function () {
        if (this.renderer instanceof CanvasRenderer) {
            this.renderer.dirtyRegionsEnabled = this.perf.dirtyRegions;
            this.renderer.batchRendering = this.perf.batchRendering;
            this.renderer.layerCacheEnabled = this.perf.layerCache;
        }
    };
    App.prototype.createRenderer = function (type) {
        var resolved = type === 'auto' ? detectBestRenderer() : type;
        if (resolved !== 'canvas' && !hasRenderer(resolved)) {
            resolved = 'canvas';
        }
        var renderer = createRenderer(resolved);
        if (renderer)
            return renderer;
        var fallback = createRenderer('canvas');
        if (fallback)
            return fallback;
        throw new Error('LightDraw: no renderer registered (load lightdraw.core first)');
    };
    App.prototype.rect = function (options) {
        return this.createNode(function () { return new Rect(options); });
    };
    App.prototype.circle = function (options) {
        return this.createNode(function () { return new Circle(options); });
    };
    App.prototype.ellipse = function (options) {
        return this.createNode(function () { return new Ellipse(options); });
    };
    App.prototype.line = function (options) {
        return this.createNode(function () { return new Line(options); });
    };
    App.prototype.arc = function (options) {
        return this.createNode(function () { return new Arc(options); });
    };
    App.prototype.polygon = function (options) {
        return this.createNode(function () { return new Polygon(options); });
    };
    App.prototype.polyline = function (options) {
        return this.createNode(function () { return new Polyline(options); });
    };
    App.prototype.path = function (options) {
        return this.createNode(function () { return new Path(options); });
    };
    App.prototype.star = function (options) {
        return this.createNode(function () { return new Star(options); });
    };
    App.prototype.roundedRect = function (options) {
        return this.createNode(function () { return new RoundedRect(options); });
    };
    App.prototype.text = function (options) {
        return this.createNode(function () { return new TextNode(options); });
    };
    App.prototype.image = function (options) {
        return this.createNode(function () { return new ImageNode(options); });
    };
    App.prototype.sprite = function (options) {
        return this.createNode(function () { return new Sprite(options); });
    };
    App.prototype.group = function (options) {
        return this.createNode(function () { return new Group(options); });
    };
    App.prototype.layer = function (options) {
        return this.createNode(function () { return new Layer(options); });
    };
    App.prototype.attachApp = function (node) {
        var e_1, _a;
        node._app = this;
        if ('children' in node) {
            try {
                for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var child = _c.value;
                    this.attachApp(child);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    App.prototype.createNode = function (factory) {
        var node = factory();
        this.attachApp(node);
        return node;
    };
    App.prototype.add = function () {
        var e_2, _a, _b;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        try {
            for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                var node = nodes_1_1.value;
                this.attachApp(node);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        (_b = this.stage).add.apply(_b, __spreadArray([], __read(nodes), false));
        this.nodeCount = countNodes(this.stage);
        this.spatialIndex.markStale();
        this.renderer.forceFullRedraw();
        this.requestRender();
        return this;
    };
    /** Called from Node.markDirty — tracks dirty regions for partial canvas clears. */
    App.prototype.markNodeDirty = function (node) {
        var b = getWorldBounds(node);
        this.renderer.markDirty(b.x, b.y, b.width, b.height);
        if (node instanceof Group && node.cacheAsBitmap && this.renderer instanceof CanvasRenderer) {
            this.renderer.layerCache.invalidate(node.id);
        }
        this.spatialIndex.markStale();
    };
    /** Called from Node.destroy — purge caches and spatial index entries. */
    App.prototype.onNodeDestroyed = function (node) {
        if (this.renderer instanceof CanvasRenderer) {
            this.renderer.layerCache.invalidate(node.id);
            if ('children' in node) {
                this.renderer.layerCache.invalidateSubtree(node);
            }
        }
        this.spatialIndex.markStale();
        this.nodeCount = Math.max(0, this.nodeCount - 1);
    };
    App.prototype.timeline = function () {
        return new Timeline();
    };
    App.prototype.animate = function (node, options) {
        return AnimationEngine.animate(node, options);
    };
    App.prototype.getFocusedNode = function () {
        var _a, _b;
        return (_b = (_a = this.eventManager) === null || _a === void 0 ? void 0 : _a.getFocusedNode()) !== null && _b !== void 0 ? _b : null;
    };
    App.prototype.isHighContrast = function () {
        return this.highContrast;
    };
    App.prototype.setHighContrast = function (enabled) {
        this.highContrast = enabled;
        this.renderer.forceFullRedraw();
        this.requestRender();
        return this;
    };
    App.prototype.focusNode = function (node) {
        var _a;
        (_a = this.eventManager) === null || _a === void 0 ? void 0 : _a.setFocus(node);
        return this;
    };
    App.prototype.getFocusableNodes = function () {
        return collectFocusable(this.stage);
    };
    App.prototype.requestRender = function () {
        var _this = this;
        if (this.renderScheduled)
            return;
        this.renderScheduled = true;
        this.renderFrameId = requestFrame(function () {
            _this.renderScheduled = false;
            _this.render();
        });
    };
    App.prototype.render = function () {
        var _a, _b, _c;
        this.updateSprites(this.stage);
        this.camera.update();
        var focusedNodeId = (_c = (_b = (_a = this.eventManager) === null || _a === void 0 ? void 0 : _a.getFocusedNode()) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null;
        this.renderer.setRenderState({ focusedNodeId: focusedNodeId, highContrast: this.highContrast });
        this.renderer.render(this.stage, this.camera.getMatrix());
        this.nodeCount = countNodes(this.stage);
        if (this.perf.spatialIndex && this.nodeCount >= this.perf.spatialIndexThreshold) {
            this.spatialIndex.ensureFresh(this.stage);
        }
    };
    App.prototype.updateSprites = function (group) {
        var e_3, _a;
        var time = typeof performance !== 'undefined' ? performance.now() : Date.now();
        try {
            for (var _b = __values(group.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (child instanceof Sprite && child.playing) {
                    child.updateFrame(time);
                }
                if ('children' in child) {
                    this.updateSprites(child);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    App.prototype.hitTest = function (worldX, worldY) {
        if (this.perf.spatialIndex && this.nodeCount >= this.perf.spatialIndexThreshold) {
            this.spatialIndex.ensureFresh(this.stage);
            var hit_1 = hitTestSpatial(this.spatialIndex, worldX, worldY);
            return hit_1 ? { node: hit_1, x: worldX, y: worldY } : null;
        }
        var hit = hitTestNode(this.stage, worldX, worldY);
        return hit ? { node: hit, x: worldX, y: worldY } : null;
    };
    App.prototype.resize = function (width, height) {
        this.width = width !== null && width !== void 0 ? width : (this.container.clientWidth || this.width);
        this.height = height !== null && height !== void 0 ? height : (this.container.clientHeight || this.height);
        this.camera.setViewport(this.width, this.height);
        this.renderer.resize(this.width, this.height, this.pixelRatio);
        this.renderer.forceFullRedraw();
        this.spatialIndex.markStale();
        this.requestRender();
    };
    App.prototype.handleResize = function () {
        this.resize();
    };
    App.prototype.getSize = function () {
        return { width: this.width, height: this.height };
    };
    App.prototype.getPixelRatio = function () {
        return this.pixelRatio;
    };
    App.prototype.getBackground = function () {
        return this.background;
    };
    /** Active renderer instance (used by export pipeline). */
    App.prototype.getRenderer = function () {
        return this.renderer;
    };
    /** Host DOM element passed to `createApp` / constructor. */
    App.prototype.getContainer = function () {
        return this.container;
    };
    App.prototype.setBackground = function (color) {
        this.background = color;
        var renderer = this.renderer;
        if (typeof renderer.setStageBackground === 'function') {
            renderer.setStageBackground(color);
        }
        else if (renderer && 'background' in renderer) {
            renderer.background = color;
        }
        this.renderer.forceFullRedraw();
        this.requestRender();
        return this;
    };
    /**
     * Apply theme pack stage background, or restore pack surface / createApp default
     * when the theme no longer provides one (clears sticky image presets).
     */
    App.prototype.syncThemeBackground = function () {
        if (this.themeModules.background) {
            this.setBackground(this.themeModules.background);
            return;
        }
        var fromTokens = this.resolvedUiTheme.surfaceMuted || this.resolvedUiTheme.surface;
        if (fromTokens) {
            this.setBackground(fromTokens);
            return;
        }
        this.setBackground(this.defaultBackground);
    };
    /** Merged theme config as last set (includes optional `preset` + module packs). Additive Phase 1 API. */
    App.prototype.getUiTheme = function () {
        return this.getTheme();
    };
    /** Full theme pack (brand + series / dashboard / diagram / automotive). */
    App.prototype.getTheme = function () {
        return composeThemePack(this.uiTheme, this.themeModules);
    };
    /** Flat resolved brand tokens after presets/overrides. Additive Phase 1 API. */
    App.prototype.getResolvedTheme = function () {
        return __assign({}, this.resolvedUiTheme);
    };
    /**
     * Apply a full theme pack from JSON or JS.
     * Default **replaces** the stored pack (clean preset switches).
     * Pass `{ merge: true }` to shallow-merge into the existing pack.
     */
    App.prototype.applyTheme = function (pack, options) {
        var normalized = normalizeThemePack(pack);
        this.ingestThemePack(normalized, !(options === null || options === void 0 ? void 0 : options.merge));
        this.publishTheme();
        return this;
    };
    /**
     * Update built-in UI theme tokens without custom stylesheets.
     * By default **merges** into existing config (omitted keys stick).
     * Pass `{ replace: true }` to replace the stored config entirely.
     * Accepts a full `ThemePack` (`series`, `dashboard`, `diagram`, `automotive`).
     *
     * Automotive widgets are intentionally **not** retinted here — they keep
     * `props.theme` presets (`classic` | `sport` | `digital`). See theme-architecture.md.
     */
    App.prototype.setUiTheme = function (tokens, options) {
        var pack = normalizeThemePack(tokens);
        this.ingestThemePack(pack, Boolean(options === null || options === void 0 ? void 0 : options.replace));
        this.publishTheme();
        return this;
    };
    /** Reset theme config to `{}` (CSS / module defaults). Equivalent to `setUiTheme({}, { replace: true })`. */
    App.prototype.clearUiTheme = function () {
        return this.setUiTheme({}, { replace: true });
    };
    /**
     * Load a scene. If the JSON root includes `theme`, it is applied first
     * (replace) so widgets build under that palette.
     * Optional second arg: `{ theme }` when the scene file has no root theme.
     */
    App.prototype.loadJSON = function (json, options) {
        var e_4, _a;
        var data;
        if (typeof json === 'string') {
            try {
                data = JSON.parse(json);
            }
            catch (err) {
                throw new SyntaxError(formatJsonParseError(json, err));
            }
        }
        else {
            data = __assign({}, json);
        }
        var _b = extractSceneTheme(data), sceneTheme = _b.theme, scene = _b.scene;
        var external = (options === null || options === void 0 ? void 0 : options.theme) ? normalizeThemePack(options.theme) : null;
        var theme = external !== null && external !== void 0 ? external : sceneTheme;
        if (theme && Object.keys(theme).length > 0) {
            this.applyTheme(theme);
        }
        var node = fromJSON(scene, this);
        this.stage.clear();
        // Hoist plain root groups so export → load → export does not nest an extra group
        if (isHoistableRootGroup(node) && node.children.length > 0) {
            try {
                for (var _c = __values(__spreadArray([], __read(node.children), false)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var child = _d.value;
                    node.remove(child);
                    this.stage.add(child);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_4) throw e_4.error; }
            }
            this.nodeCount = countNodes(this.stage);
            this.spatialIndex.clear();
            this.renderer.forceFullRedraw();
            this.requestRender();
            return this.stage.children.length === 1 ? this.stage.children[0] : this.stage;
        }
        this.stage.add(node);
        this.nodeCount = countNodes(this.stage);
        this.spatialIndex.clear();
        this.renderer.forceFullRedraw();
        this.requestRender();
        return node;
    };
    /** Export scene. Pass `{ includeTheme: true }` to embed the current theme pack. */
    App.prototype.exportJSON = function (options) {
        var scene = exportStageJSON(this.stage, { compact: options === null || options === void 0 ? void 0 : options.compact });
        if (options === null || options === void 0 ? void 0 : options.includeTheme) {
            var theme = this.getTheme();
            if (Object.keys(theme).length > 0) {
                return __assign(__assign({}, scene), { theme: theme });
            }
        }
        return scene;
    };
    /** Ingest pack into uiTheme + themeModules and re-resolve (no emit). */
    App.prototype.ingestThemePack = function (pack, replace) {
        var _a, _b;
        var next = replace ? pack : mergeThemePacks(this.getTheme(), pack);
        var split = splitThemePack(next);
        this.uiTheme = __assign({}, split.ui);
        var resolvedBg = resolveThemeBackground(__assign(__assign({}, split.ui), { background: split.background }));
        this.themeModules = {
            series: split.series,
            dashboard: split.dashboard,
            diagram: split.diagram,
            automotive: split.automotive,
            background: resolvedBg,
        };
        this.resolvedUiTheme = resolveUiTheme(this.uiTheme);
        var dashPack = __assign(__assign({}, ((_a = this.themeModules.dashboard) !== null && _a !== void 0 ? _a : {})), (((_b = this.themeModules.series) === null || _b === void 0 ? void 0 : _b.length)
            ? { series: __spreadArray([], __read(this.themeModules.series), false) }
            : {}));
        syncActiveCanvasUiTheme(this.resolvedUiTheme, this);
        syncActiveDashboardTheme(this.resolvedUiTheme, this, dashPack);
        syncActiveDiagramTheme(this.resolvedUiTheme, this, this.themeModules.diagram);
        var prevAutoScale = getAutomotiveFontScale(this);
        var nextAutoScale = syncAutomotiveFontScale(this.resolvedUiTheme, this);
        syncAutomotiveDefaultPreset(this.themeModules.automotive, this);
        this.automotiveFontScaleDirty = prevAutoScale !== nextAutoScale;
    };
    /** Apply resolved theme to renderer + live widgets and emit themechange. */
    App.prototype.publishTheme = function () {
        var renderer = this.renderer;
        if (typeof renderer.setUiTheme === 'function') {
            renderer.setUiTheme(this.resolvedUiTheme);
        }
        this.syncThemeBackground();
        refreshCanvasUi(this.stage, this);
        refreshDashboard(this.stage, this);
        refreshDiagram(this.stage, this);
        if (this.automotiveFontScaleDirty) {
            refreshAutomotive(this.stage);
            this.automotiveFontScaleDirty = false;
        }
        this.emit('themechange', syntheticEvent('themechange', this, {
            payload: {
                config: this.getTheme(),
                resolved: this.getResolvedTheme(),
            },
        }));
        this.requestRender();
    };
    App.prototype.export = function (formatOrOptions) {
        if (typeof formatOrOptions === 'object') {
            return exportApp(this, formatOrOptions);
        }
        return exportScene(this, formatOrOptions);
    };
    App.prototype.toDataURL = function (type, quality) {
        if (type === void 0) { type = 'image/png'; }
        return this.renderer.toDataURL(type, quality);
    };
    /** Remove all nodes from the scene (keeps the App instance). */
    App.prototype.clear = function () {
        this.stage.clear();
        this.nodeCount = 0;
        this.spatialIndex.clear();
        this.renderer.forceFullRedraw();
        this.requestRender();
        return this;
    };
    App.prototype.destroy = function () {
        var _a;
        if (this.renderFrameId)
            cancelFrame(this.renderFrameId);
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
        (_a = this.eventManager) === null || _a === void 0 ? void 0 : _a.destroy();
        if (this.renderer instanceof CanvasRenderer) {
            this.renderer.layerCache.destroy();
        }
        this.spatialIndex.clear();
        this.renderer.destroy();
        this.stage.clear();
        this.removeAllListeners();
    };
    App.use = function (plugin, LightDrawRef) {
        var ld = LightDrawRef !== null && LightDrawRef !== void 0 ? LightDrawRef : globalThis.__LightDraw;
        if (ld)
            installPlugin(plugin, ld);
    };
    return App;
}(EventEmitter));
export { App };
